/* eslint-disable max-lines*/
/* eslint-disable max-len */
/* eslint-disable xss/no-mixed-html*/
/* eslint-disable max-statements*/
/* eslint-disable require-jsdoc */
/* eslint-disable vars-on-top */
ACC.common = {
  currentPath: window.location.pathname,
  currentCurrency: 'USD',
  $page: $('#page'),
  pdpQuantityCls: 'ph-pdpquantity',
  $globalMessages: $('#globalMessages'),

  setCurrentCurrency: function() {
    ACC.common.currentCurrency = ACC.common.$page.data('currencyIsoCode');
  },

  refreshScreenReaderBuffer: function() {
    /* Changes a value in a hidden form field in order
       To trigger a buffer update in a screen reader */
    $('#accesibility_refreshScreenReaderBufferField').attr('value', new Date().getTime());
  },

  bindAll: function() {
    ACC.common.bindToUiCarouselLink();
    ACC.common.bindShowProcessingMessageToSubmitButton();
  },

  bindToUiCarouselLink: function() {
    $('ul.carousel > li a.popup').colorbox({
      onComplete: function() {
        ACC.common.refreshScreenReaderBuffer();
        $.colorbox.resize();
        ACC.product.initQuickviewLightbox();
      },

      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  },
  /* eslint-disable dollar-sign/dollar-sign*/
  processingMessage: $('<img src=\'' + ACC.config.commonResourcePath + '/images/spinner.gif\'/>'),
  /* eslint-enable dollar-sign/dollar-sign*/
  bindShowProcessingMessageToSubmitButton: function() {
    $(':submit.show_processing_message').each(function() {
      $(this).on('click', ACC.common.showProcessingMessageAndBlockForm);
    });
  },

  showProcessingMessageAndBlockForm: function() {
    $('#checkoutContentPanel').block({
      message: ACC.common.processingMessage
    });
  },

  blockFormAndShowProcessingMessage: function(submitButton) {
    var form = submitButton.parents('form:first');

    form.block({
      message: ACC.common.processingMessage
    });
  },

  showSpinner: function(message) {
    $('.spinner-wrapper').show();
    $('#spinnerMessage').html(message);
  },

  showSpinnerById: function(elementid) {
    $('#' + elementid).show();
  },

  hideSpinner: function() {
    $('.spinner-wrapper').hide();
    $('#spinnerMessage').html('');
  },

  hideSpinnerById: function(elementid) {
    $('#' + elementid).hide();
  },
  createUserEventObj: function(url, desc, trigger, compname) {
    return {
      url: url,
      description: desc,
      trigger: trigger,
      compname: compname
    };
  },
  commoncountdownbar: function() {
    var enddatebar = $('#ph-countdownenddate').val(),
        currdatebar = $('#ph-countdowncurrdate').val(),
        enddate = new Date(enddatebar),
        startdate = new Date(currdatebar),
        distance = enddate - startdate,
        countdowndays = '',
        countdownhours = '',
        countdownmins = '',
        countdownsecs = '',
        countnumber = '',
        promotionurl = $('#ph-countdownpromourl').val(),
        promoanchortag = '.ph-countdownurl',
        countdownbarcontainer = '.ph-countdownbarcontainer',
        countdays = $('.ph-countdays').val(),
        counthours = $('.ph-counthours').val(),
        countmin = $('.ph-countmin').val(),
        countsec = $('.ph-countsec').val(),
        opencountvalue = '</span><span class="ph-countvalue">';

    var setcountdowntime = setInterval(function() {
      countdowndays = Math.floor(distance / (1000 * 60 * 60 * 24));
      countdownhours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      countdownmins = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      countdownsecs = Math.floor((distance % (1000 * 60)) / 1000);
      countnumber = '<span class="ph-countnumber">';

      document.getElementById('ph-countdowndays').innerHTML = countnumber + countdowndays + opencountvalue + countdays + '</span>';
      document.getElementById('ph-countdownhours').innerHTML = countnumber + countdownhours + opencountvalue + counthours + '</span>';
      document.getElementById('ph-countdownmins').innerHTML = countnumber + countdownmins + opencountvalue + countmin + '</span>';
      document.getElementById('ph-countdownsecs').innerHTML = countnumber + countdownsecs + opencountvalue + countsec + '</span>';

      distance = distance - 1000;

      if (distance < 0) {
        clearInterval(setcountdowntime);
        document.getElementById('ph-countdowndays').innerHTML = '';
        document.getElementById('ph-countdownhours').innerHTML = '';
        document.getElementById('ph-countdownmins').innerHTML = '';
        document.getElementById('ph-countdownsecs').innerHTML = '';
      }
    }, 1000);

    /* eslint-disable no-negated-condition */
    if (promotionurl !== '') {
      /* eslint-enable no-negated-condition */
      $(promoanchortag).css('pointer-events', 'auto');

      if (promotionurl.indexOf('http://') === 0 || promotionurl.indexOf('https://') === 0) {
        $(promoanchortag).attr('href', promotionurl).attr('target', '_blank');
      } else {
        $(promoanchortag).attr('href', ACC.config.encodedContextPath + '/' + promotionurl).attr('target', '_self');
      }

      $(document).on('click', countdownbarcontainer, function() {
        var basepath = window.location.protocol + '//' + window.location.host,
            linkpath = $(this).parent().attr('href'),
            relativePath = ACC.config.encodedContextPath + linkpath,
            url = '',
            clickdescription = 'Click on CountDown Bar - ',
            desc = clickdescription + $(this).find('.ph-countdisaplytext').text().trim(),
            trigger = 'linkCategory.clickCountdownbar',
            compname = 'linkCountdownbar',
            userEventObj = '';

        if (promotionurl.indexOf('http://') === 0 || promotionurl.indexOf('https://') === 0) {
          url = linkpath;
        } else {
          url = basepath + relativePath;
        }

        userEventObj = ACC.common.createUserEventObj(url, desc, trigger, compname);
        ACC.googleanalytics.gaEventsForLinks(userEventObj);
      });
    } else {
      $(promoanchortag).css('pointer-events', 'none');
    }

    if ($('.ph-countdownspacebredcrumb').length > 0) {
      $('.ph-container').removeClass('ph-countdownspace');
    }

    if (!$(countdownbarcontainer).is(':visible')) {
      $('.ph-countdownspacebredcrumb').css('margin-top', '0px');
    }
  },
  updateContextPathToUrl: function() {
    $('.ph-notifycontentpara a').each(function() {
      var url = $(this).attr('href');

      if (url.indexOf('http://') === 0 || url.indexOf('https://') === 0) {
        $(this).attr('href', url).attr('target', '_blank');
      } else {
        $(this).attr('href', ACC.config.encodedContextPath + url).attr('target', '_self');
      }
    });
  },
  recentnotifytitle: function(notifiationid, notifyloopindex) {
    var txtNotifyBalloon = '.ph-notify-balloon',
        notifybaloon = $(txtNotifyBalloon).text();

    $.ajax({
      url: ACC.config.encodedContextPath + '/notifications/notification',
      type: 'GET',
      datatype: 'json',
      data: {
        /* eslint-disable id-length */
        id: notifiationid
        /* eslint-enable id-length */
      },
      success: function(response) {
        var $respcontent = $($.parseHTML(response.content));

        $('.ph-notificationdate').text(response.creationDate);
        $('.ph-notifycontenttitle').text(response.contentTitle);
        $('.ph-notifycontentpara').html($respcontent);
        ACC.common.updateContextPathToUrl();

        if (response.isRead === true && $('.ph-notifystatus-' + notifyloopindex).attr('data-read') === 'false') {
          notifybaloon = notifybaloon - 1;

          if (notifybaloon === 0) {
            $(txtNotifyBalloon).hide();
          }

          $(txtNotifyBalloon).text(notifybaloon);
          $('.ph-notifystatus-' + notifyloopindex).attr('data-read', 'true');
        }
      }
    });
  },
  additionstyle: function($currentelem, notifyselected) {
    $('.ph-notifynav').removeClass(notifyselected);
    $currentelem.parent().addClass(notifyselected);
    $currentelem.addClass('ph-readnotification');
  },
  getBlockedProductList: function() {
    var $blockedProducts = $('.ph-blockedlist'),
        blockProductCodes = [];

    $.each($blockedProducts, function() {
      blockProductCodes.push($(this).attr('data-blockedprdcode'));
    });

    return blockProductCodes;
  },
  checkForBlockedProducts: function(productCode) {
    var blockProductCodes = '',
        disableBtn = 'ph-outofstockdisablebtn',
        blockedCls = '.ph-blocked-',
        blocknotifyMe = '.ph-blknotify-';

    blockProductCodes = ACC.common.getBlockedProductList();

    if (blockProductCodes.includes(productCode)) {
      $(blockedCls + productCode).find('.ph-cart').addClass(disableBtn);
      $(blocknotifyMe + productCode).find('.ph-notifyme-button').removeClass('ph-blue-button').addClass(disableBtn);
      $(blocknotifyMe + productCode).addClass('ph-blk-notifyme');
      $(blocknotifyMe + productCode).parent().addClass('ph-blk-notifymepdp');
      $(blockedCls + productCode).parent().addClass('ph-tooltip-parent');
      $(blockedCls + productCode).addClass('ph-blocked-cartbtn');
    }
  },
  isBlockedProduct: function(productCode) {
    var productList = '',
        isBlocked = false;

    productList = ACC.common.getBlockedProductList();

    if (productList.includes(productCode)) {
      isBlocked = true;
    }

    return isBlocked;
  },
  setCarouselWidth: function($jcarousel, width, noOfCards) {
    var containerWidth = Math.ceil(width) * noOfCards,
        labelWidth = 'width',
        labelPx = 'px',
        productCard = 'ph-ra_productcard',
        $homepageCarrousel = $('.ph-homepage-suggested .ph-recentlyviewed-products__jcarousel'),
        $suggestedPrd = $('.ph-suggestedprd-carrousel .ph-suggested-products__jcarousel'),
        $recentlyviewedPrd = $('.ph-rcvproduct-carrousel .ph-recentlyviewed-products__jcarousel'),
        $additionalprd = $('.ph-additionalprd-carrousel .ph-recentlyviewed-products__jcarousel');

    $suggestedPrd.css(labelWidth, containerWidth + labelPx);
    $recentlyviewedPrd.css(labelWidth, containerWidth + labelPx);
    $additionalprd.css(labelWidth, containerWidth + labelPx);
    $suggestedPrd.find('.' + productCard).css(labelWidth, width + labelPx);
    $recentlyviewedPrd.find('.' + productCard).css(labelWidth, width + labelPx);
    $additionalprd.find('.' + productCard).css(labelWidth, width + labelPx);
    $homepageCarrousel.css(labelWidth, '1038' + labelPx);
  },
  showRatingsConfirmationPopup: function(url) {
    var popupWidth = '40%';

    if ($(window).width() < 1024) {
      popupWidth = '95%';
    }

    $.colorbox({
      maxWidth: '630px',
      width: popupWidth,
      scrolling: true,
      html: $('.ph-ratingsconf_popup').html(),
      onComplete: function() {
        $('.ph-ratings-okbutton').attr('data-navurl', url);
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  },
  // eslint-disable-next-line max-params
  getLowestMaxQtyValue: function(nobackorderprod, maxQtyEnabled, enteredQty, lowStockQty, maxQty, totalOrdered, isFreeMarketingProduct, freeMarketingMaxQty) {
    var maxQtyReqParams = {
      nobackorderprod: nobackorderprod,
      maxQtyEnabled: maxQtyEnabled,
      enteredQty: enteredQty,
      lowStockQty: lowStockQty,
      maxQty: maxQty,
      totalOrdered: totalOrdered,
      isFreeMarketingProduct: isFreeMarketingProduct,
      freeMarketingMaxQty: freeMarketingMaxQty,
      dChainProductToggle: '',
      dChainProductValue: '',
      dChainProductFirstEntryDate: '',
      dChainProductFirstEntryQty: ''
    };

    return ACC.common.checkAllMaxQtyValidation(maxQtyReqParams);
  },
  checkDChainDateIslessThanToday: function(dChainProductFirstEntryDate) {
    var todayDate = new Date(),
        firstEntryDate = '';

    if (dChainProductFirstEntryDate !== '') {
      var dtParts = dChainProductFirstEntryDate.split('/');

      firstEntryDate = new Date(dtParts[1] + '/' + dtParts[0] + '/' + dtParts[2]);
    }

    todayDate.setHours(0, 0, 0, 0);

    if (dChainProductFirstEntryDate === '' || firstEntryDate <= todayDate) {
      return true;
    }

    return false;
  },
  /* eslint-disable complexity, no-negated-condition, no-undefined, no-ternary */
  checkAllMaxQtyValidation: function(maxQtyReqParams) {
    var nobackorderprod = maxQtyReqParams.nobackorderprod,
        lowStockQty = maxQtyReqParams.lowStockQty,
        maxQtyEnabled = maxQtyReqParams.maxQtyEnabled,
        maxQty = maxQtyReqParams.maxQty !== undefined ? maxQtyReqParams.maxQty : -1,
        totalOrdered = maxQtyReqParams.totalOrdered !== undefined ? maxQtyReqParams.totalOrdered : 0,
        isFreeMarketingProduct = maxQtyReqParams.isFreeMarketingProduct !== undefined ? maxQtyReqParams.isFreeMarketingProduct : false,
        freeMarketingMaxQty = maxQtyReqParams.freeMarketingMaxQty !== undefined ? maxQtyReqParams.freeMarketingMaxQty : -1,
        enteredQty = maxQtyReqParams.enteredQty,
        dChainProductToggle = maxQtyReqParams.dChainProductToggle,
        dChainProductValue = maxQtyReqParams.dChainProductValue,
        // eslint-disable-next-line capitalized-comments
        // dChainProductFirstEntryDate = maxQtyReqParams.dChainFirstEntryDate !== undefined ? maxQtyReqParams.dChainFirstEntryDate : '',
        dChainProductFirstEntryQty = maxQtyReqParams.dChainProductFirstEntryQty !== undefined ? maxQtyReqParams.dChainProductFirstEntryQty : 0,

        backorderAndLowStockFlag = (nobackorderprod === true || nobackorderprod === 'true') && lowStockQty > 0,
        maxQtyFlag = (maxQtyEnabled === true || maxQtyEnabled === 'true') && maxQty > 0,
        freeMarketingFlag = (isFreeMarketingProduct === true || isFreeMarketingProduct === 'true') && freeMarketingMaxQty > 0,
        // eslint-disable-next-line id-match
        dChain50Flag = (dChainProductToggle === true || dChainProductToggle === 'true') && dChainProductValue === '50' && dChainProductFirstEntryQty > 0,
        // eslint-disable-next-line id-match
        dChain30Flag = (nobackorderprod === true || nobackorderprod === 'true') && (dChainProductToggle === true || dChainProductToggle === 'true') && dChainProductValue === '30' && dChainProductFirstEntryQty > 0,
        maxQtyListArr = [],
        lowestQtyName = {
          qtyName: '',
          qtyValue: 0
        };

    if (backorderAndLowStockFlag) {
      maxQtyListArr.push({
        qtyName: 'lowStock',
        qtyValue: lowStockQty
      });
    }

    if (maxQtyFlag) {
      maxQtyListArr.push({
        qtyName: 'maxQty',
        qtyValue: maxQty - totalOrdered
      });
    }

    if (freeMarketingFlag) {
      maxQtyListArr.push({
        qtyName: 'freeMarketingMaxQty',
        qtyValue: freeMarketingMaxQty
      });
    }

    if (dChain50Flag) {
      maxQtyListArr.push({
        qtyName: 'dChain50',
        qtyValue: dChainProductFirstEntryQty
      });
    }

    if (dChain30Flag) {
      maxQtyListArr.push({
        qtyName: 'dChain30',
        qtyValue: dChainProductFirstEntryQty
      });
    }

    for (var qtyIndex = 0; qtyIndex < maxQtyListArr.length; qtyIndex = qtyIndex + 1) {
      if (qtyIndex === 0) {
        lowestQtyName = maxQtyListArr[0];
      } else {
        // eslint-disable-next-line no-lonely-if
        if (maxQtyListArr[qtyIndex].qtyValue < lowestQtyName.qtyValue) {
          lowestQtyName = maxQtyListArr[qtyIndex];
        }
      }
    }

    if (enteredQty > lowestQtyName.qtyValue) {
      return lowestQtyName.qtyName;
    }

    return '';
  },
  /* eslint-enable complexity, no-negated-condition, no-undefined, no-ternary */
  requestPopup: function() {
    $('.ph-interstitial-loader').removeClass('hidden');
    $('.ph-popup_overlay').removeClass('hidden');
  },
  getDChainFirstEntry: function(prodAtpData) {
    var atpTraficData = prodAtpData.atpData.atpTrafficLightMap,
        indx = 0,
        obj = {};

    if (atpTraficData !== null && Object.keys(atpTraficData).length > 0) {
      for (var prop in atpTraficData) {
        if (indx === 0) {
          // eslint-disable-next-line security/detect-object-injection
          obj[prop] = atpTraficData[prop];
          indx = indx + 1;

          return obj;
        }
      }
    }

    return null;
  },
  getLowestQtyNameFromObjList: function(maxQtyListArr, enteredQty) {
    var lowestQtyName = {
      qtyName: '',
      qtyValue: 0
    };

    for (var qtyIndex = 0; qtyIndex < maxQtyListArr.length; qtyIndex = qtyIndex + 1) {
      if (qtyIndex === 0) {
        lowestQtyName = maxQtyListArr[0];
      } else {
        // eslint-disable-next-line no-lonely-if
        if (maxQtyListArr[qtyIndex].qtyValue < lowestQtyName.qtyValue) {
          lowestQtyName = maxQtyListArr[qtyIndex];
        }
      }
    }

    if (enteredQty > lowestQtyName.qtyValue) {
      return lowestQtyName.qtyName;
    }

    return '';
  },
  getAtpDataFromGlobalVar: function(productCode) {
    var atpDataList = PHI.common.productATPDataList;

    if (atpDataList.length > 0) {
      for (var indx = 0; indx < atpDataList.length; indx = indx + 1) {
        if (atpDataList[indx].code === productCode) {
          return atpDataList[indx];
        }
      }
    }

    return '';
  },
  getMaxQtyDataFromGlobalVar: function(productCode) {
    var maxQtyDataList = PHI.common.productMaxQtyDataList;

    if (maxQtyDataList.length > 0) {
      for (var indx = 0; indx < maxQtyDataList.length; indx = indx + 1) {
        if (maxQtyDataList[indx].productCode === productCode) {
          return maxQtyDataList[indx];
        }
      }
    }

    return '';
  }
};

$(document).ready(function() {
  var recentnotification = $('.ph-navmenu li').first(),
      recentnotifyid = recentnotification.find('a').attr('id'),
      recentnotifyloopindex = recentnotification.find('a').attr('data-index'),
      shownotificationdesk = '.ph-shownotificationdesk',
      $notifypage = $('.ph-mynotify_page'),
      $notifynavigation = $('.ph-notificationNav'),
      notifyback = '.ph-notifyback',
      notifyselected = 'ph-notifyselected';

  ACC.common.setCurrentCurrency();
  ACC.common.bindAll();
  ACC.common.bindShowProcessingMessageToSubmitButton();

  if ($('.ph-countdownbarcontainer').length > 0) {
    ACC.common.commoncountdownbar();
  }

  if ($('.ph-notificationcontainer').length > 0) {
    recentnotification.addClass(notifyselected);
    recentnotification.find('a').addClass('ph-readnotification');
    ACC.common.recentnotifytitle(recentnotifyid, recentnotifyloopindex);

    $(document).on('click', shownotificationdesk, function() {
      var notifiationid = $(this).attr('id'),
          notifyloopindex = $(this).attr('data-index'),
          $currentelem = $(this);

      ACC.common.recentnotifytitle(notifiationid, notifyloopindex);
      ACC.common.additionstyle($currentelem, notifyselected);

      if ($(window).width() < 768) {
        $notifypage.show();
        $notifynavigation.hide();
        $(notifyback).removeClass('hidden');
      }
    });
    $(document).on('click', notifyback, function() {
      $notifypage.hide();
      $notifynavigation.show();
      $(window).scrollTop(0);
      $(notifyback).addClass('hidden');
    });

    if ($(window).width() < 768) {
      $notifypage.hide();
      $notifynavigation.show();
    }
  }
});


/* eslint-disable no-undef */
jQuery.extend({
  postJSON: function(url, data, callback) {
    return jQuery.post(url, data, callback, 'json');
    /* eslint-enable no-undef */
  }
});

// Add a CSRF request token to POST ajax request if its not available
$.ajaxPrefilter(function(options, event) { /* eslint-disable init-declarations*/
  var noData;/* eslint-enable init-declarations*/

  // Modify options, control originalOptions, store jqXHR, etc
  if (options.type === 'post' || options.type === 'POST') {
    noData = typeof options.data === 'undefined';


    /* eslint-disable no-negated-condition*/
    /* eslint-disable no-ternary*/
    /* eslint-disable no-prototype-builtins */
    /* eslint-disable no-mixed-operators*/
    if ($('.ph-neworderreturn').is(event.target) && noData || (typeof options.data === 'object' && options.data.hasOwnProperty('CSRFToken') === false)) {
      options.data.append('CSRFToken', ACC.config.CSRFToken);
    } else if (noData || options.data.indexOf('CSRFToken') === -1) {
      options.data = (!noData ? options.data + '&' : '') + 'CSRFToken=' + ACC.config.CSRFToken;
      /* eslint-enable no-ternary*/
      /* eslint-enable no-negated-condition*/
      /* eslint-enable no-mixed-operators*/
    }
  }
  /* eslint-enable no-prototype-builtins */
});
$(document).ready(function() {
  var $phEyeIcon = $('#ph-eyeicon');

  if ($('.pageLabel-login').length > 0) {
    $phEyeIcon.show();
  } else {
    $phEyeIcon.hide();
  }

  $phEyeIcon.click(function() {
    var txtInput = '.ph-pwdinput',
        $input = $(txtInput);

    if ($input.attr('type') === 'password') {
      $(this).attr('src', ACC.config.commonResourcePath + '/../theme-philips/img/pwd-hide.svg');
      $(txtInput).prop('type', 'text');
    } else {
      $(this).attr('src', ACC.config.commonResourcePath + '/../theme-philips/img/pwd-show.svg');
      $(txtInput).prop('type', 'password');
    }
  });

  if (location.hash.includes('#contactdetails-sec')) {
    setTimeout(function() {
      $(window).scrollTop($('.ph-contact-mb').offset().top - 100);
    }, 10);
  }

  if (location.hash.includes('#myprofile-sec')) {
    setTimeout(function() {
      $(window).scrollTop($('.ph-profile_section').offset().top - 100);
    }, 10);
  }

  if ($('.ph-loggedin-tooltip').length > 0 && $('#ph-remember_me_checkbox_enable').val() === 'false') {
    $.idleHands({
      applicationId: 'my_application',
      heartRate: 15,
      inactivityDialogDuration: 120,
      inactivityLogoutUrl: $('.ph-signout').attr('href'),
      maxInactivitySeconds: Number($('.ph-philipsSessionTimeOut').val())
    });
  }

  $('.ph-ratingAndreview').each(function() {
    if ($(this).attr('data-url') !== '' && $(this).attr('data-url') !== 'null') {
      $(this).css('cursor', 'pointer');
      $(this).on('click', function() {
        var ratingUrl = $(this).attr('data-url'),
            ratingNumber = $(this).attr('data-rating');

        if (ratingNumber > 0) {
          ACC.common.showRatingsConfirmationPopup(ratingUrl);
        }
      });
    } else {
      $(this).css('cursor', 'default');
    }
  });
});

$(document).scroll(function() {
  var pageHeight = $(this).scrollTop();

  if (pageHeight > 1000) {
    $('.ph-backtotop').removeClass('ph-d-none');
  }
});
$('.ph-decisionpage__bottomcontent .add_to_cart_form').on('keyup keypress', function(event) {
  var keyCode = event.keyCode || event.which;

  if (keyCode === 13) {
    event.preventDefault();

    return false;
  }

  return true;
});


$(document).ready(function() {
  var blockedStatus = '',
      pdpaddtocartbtn = '.ph-pdp_addtocart_button',
      txtDisable = 'ph-disable-button',
      placeOrderButtonId = '#Place-order-button',
      phDisableButtonClass = 'ph-disable-button',
      deliveryoptionShowstatus = $('#deliveryoptionFlag').val(),
      deliveryStatusContainer = $('.ph-wholeDeliveryOptions').length,
      defaultCode = $('.ph-defaultCode').val(),
      interstitialLoader = '.ph-interstitial-loader',
      deliverymodeVal = '';

  if ($('.pe_validate').length > 0) {
    $('.ph-username').focus();
  }

  if ($(pdpaddtocartbtn).length > 0) {
    blockedStatus = $(pdpaddtocartbtn).attr('data-blocked');
  }


  if (blockedStatus === 'true') {
    $(pdpaddtocartbtn).addClass(txtDisable);
    $('.ph-notifypdp-wrapper').addClass('ph-disable_notify');
    $('.ph-notify-sec').addClass(txtDisable);
  }

  function validatePoNumber() {
    var regexAllCharacters = new RegExp(/^.{0,35}$/),
        regexDoubleQuotes = new RegExp(/^[^"]*$/i),
        $poNumberBox = $('#purchaseOrderNumber'),
        poNumberVal = $poNumberBox.val();

    $poNumberBox.closest('.ph-form__fieldwrap').removeClass('ph-form-field-error');

    if (!regexAllCharacters.test(poNumberVal) || !regexDoubleQuotes.test(poNumberVal)) {
      $poNumberBox.closest('.ph-form__fieldwrap').addClass('ph-form-field-error');

      return false;
    }

    return true;
  }

  /* eslint-disable complexity*/
  function enableOrderButton() {
    var poMandatory = document.getElementById('poNumberEnable'),
        termsCheckMandatory = document.getElementById('termsCheck'),
        hasNoErrorMsg = !document.getElementById('errorMsgOrder'),
        poNoValidated = !validatePoNumber();

    if ($('.otafields:visible').length > 0) {
      deliveryoptionShowstatus = 'false';
    }

    if (hasNoErrorMsg && !poMandatory && !termsCheckMandatory && (deliveryoptionShowstatus === 'true' &&
deliveryStatusContainer > 0 && $('input[name="modeCode"]').is(':checked')) && poNoValidated) {
      $(placeOrderButtonId).removeClass(phDisableButtonClass);
    } else if (hasNoErrorMsg && !poMandatory && !termsCheckMandatory && (deliveryoptionShowstatus === 'true' &&
deliveryStatusContainer === 0) && poNoValidated) {
      $(placeOrderButtonId).removeClass(phDisableButtonClass);
    } else if (hasNoErrorMsg && !poMandatory && !termsCheckMandatory &&
      (deliveryoptionShowstatus === 'false' && deliveryStatusContainer === 0) && poNoValidated) {
      $(placeOrderButtonId).removeClass(phDisableButtonClass);
    } else {
      $(placeOrderButtonId).addClass(phDisableButtonClass);
    }
  }

  function enableButtonOnTermsCheck() {
    var poMandatory = document.getElementById('poNumberEnable'),
        termsCheckMandatory = document.getElementById('termsCheck'),
        hasNoErrorMsg = !document.getElementById('errorMsgOrder');

    if ($('.otafields:visible').length > 0) {
      deliveryoptionShowstatus = 'false';

      if (!PHI.checkout.onetimeAllFieldValidation(true)) {
        hasNoErrorMsg = false;
      }
    }

    if ($('#otaValidationCheck').length > 0 && $('#otaValidationCheck').val() === 'failed') {
      hasNoErrorMsg = false;
    }


    if (!validatePoNumber()) {
      hasNoErrorMsg = false;
    }

    if (hasNoErrorMsg) {
      if (poMandatory && termsCheckMandatory && $('#termsCheck').is(':checked') && $('#purchaseOrderNumber').val() !== '' &&
(deliveryoptionShowstatus === 'false' && deliveryStatusContainer === 0)) {
        $(placeOrderButtonId).removeClass(phDisableButtonClass);
      } else if (poMandatory && termsCheckMandatory && $('#termsCheck').is(':checked') && $('#purchaseOrderNumber').val() !== '' &&
(deliveryoptionShowstatus === 'true' && deliveryStatusContainer > 0 && $('input[name="modeCode"]').is(':checked'))) {
        $(placeOrderButtonId).removeClass(phDisableButtonClass);
      } else if (poMandatory && termsCheckMandatory && $('#termsCheck').is(':checked') && $('#purchaseOrderNumber').val() !== '' &&
(deliveryoptionShowstatus === 'true' && deliveryStatusContainer === 0)) {
        $(placeOrderButtonId).removeClass(phDisableButtonClass);
      } else if (!poMandatory && termsCheckMandatory && $('#termsCheck').is(':checked') && (deliveryoptionShowstatus === 'false' &&
deliveryStatusContainer === 0)) {
        $(placeOrderButtonId).removeClass(phDisableButtonClass);
      } else if (!poMandatory && termsCheckMandatory && $('#termsCheck').is(':checked') &&
(deliveryoptionShowstatus === 'true' && deliveryStatusContainer > 0 && $('input[name="modeCode"]').is(':checked'))) {
        $(placeOrderButtonId).removeClass(phDisableButtonClass);
      } else if (!poMandatory && termsCheckMandatory && $('#termsCheck').is(':checked') &&
(deliveryoptionShowstatus === 'true' && deliveryStatusContainer === 0)) {
        $(placeOrderButtonId).removeClass(phDisableButtonClass);
      } else if (!poMandatory && !termsCheckMandatory && (deliveryoptionShowstatus === 'false' &&
deliveryStatusContainer === 0)) {
        $(placeOrderButtonId).removeClass(phDisableButtonClass);
      } else if (!poMandatory && !termsCheckMandatory && (deliveryoptionShowstatus === 'true' &&
deliveryStatusContainer > 0 && $('input[name="modeCode"]').is(':checked'))) {
        $(placeOrderButtonId).removeClass(phDisableButtonClass);
      } else if (!poMandatory && !termsCheckMandatory && (deliveryoptionShowstatus === 'true' && deliveryStatusContainer === 0)) {
        $(placeOrderButtonId).removeClass(phDisableButtonClass);
      } else {
        $(placeOrderButtonId).addClass(phDisableButtonClass);
      }
    } else {
      $(placeOrderButtonId).addClass(phDisableButtonClass);
    }
  }

  function activateButtonOnPoNumber() {
    var poMandatory = document.getElementById('poNumberEnable'),
        termsCheckMandatory = document.getElementById('termsCheck'),
        hasNoErrorMsg = !document.getElementById('errorMsgOrder');

    if ($('.otafields:visible').length > 0) {
      deliveryoptionShowstatus = 'false';

      if (!PHI.checkout.onetimeAllFieldValidation(true)) {
        hasNoErrorMsg = false;
      }
    }

    if ($('#otaValidationCheck').length > 0 && $('#otaValidationCheck').val() === 'failed') {
      hasNoErrorMsg = false;
    }

    if (!validatePoNumber()) {
      hasNoErrorMsg = false;
    }

    if (hasNoErrorMsg) {
      if (poMandatory && termsCheckMandatory && $('#termsCheck').is(':checked') && $('#purchaseOrderNumber').val() !== '' &&
(deliveryoptionShowstatus === 'false' && deliveryStatusContainer === 0)) {
        $(placeOrderButtonId).removeClass(phDisableButtonClass);
      } else if (poMandatory && termsCheckMandatory && $('#termsCheck').is(':checked') && $('#purchaseOrderNumber').val() !== '' &&
(deliveryoptionShowstatus === 'true' && deliveryStatusContainer > 0 && $('input[name="modeCode"]').is(':checked'))) {
        $(placeOrderButtonId).removeClass(phDisableButtonClass);
      } else if (poMandatory && termsCheckMandatory && $('#termsCheck').is(':checked') && $('#purchaseOrderNumber').val() !== '' &&
(deliveryoptionShowstatus === 'true' && deliveryStatusContainer === 0)) {
        $(placeOrderButtonId).removeClass(phDisableButtonClass);
      } else if (poMandatory && !termsCheckMandatory && $('#purchaseOrderNumber').val() !== '' &&
(deliveryoptionShowstatus === 'false' && deliveryStatusContainer === 0)) {
        $(placeOrderButtonId).removeClass(phDisableButtonClass);
      } else if (poMandatory && !termsCheckMandatory && $('#purchaseOrderNumber').val() !== '' &&
(deliveryoptionShowstatus === 'true' && deliveryStatusContainer > 0 && $('input[name="modeCode"]').is(':checked'))) {
        $(placeOrderButtonId).removeClass(phDisableButtonClass);
      } else if (poMandatory && !termsCheckMandatory && $('#purchaseOrderNumber').val() !== '' &&
(deliveryoptionShowstatus === 'true' && deliveryStatusContainer === 0)) {
        $(placeOrderButtonId).removeClass(phDisableButtonClass);
      } else if (!poMandatory && termsCheckMandatory && $('#termsCheck').is(':checked') &&
(deliveryoptionShowstatus === 'false' && deliveryStatusContainer === 0)) {
        $(placeOrderButtonId).removeClass(phDisableButtonClass);
      } else if (!poMandatory && termsCheckMandatory && $('#termsCheck').is(':checked') &&
(deliveryoptionShowstatus === 'true' && deliveryStatusContainer > 0 && $('input[name="modeCode"]').is(':checked'))) {
        $(placeOrderButtonId).removeClass(phDisableButtonClass);
      } else if (!poMandatory && termsCheckMandatory && $('#termsCheck').is(':checked') &&
(deliveryoptionShowstatus === 'true' && deliveryStatusContainer === 0)) {
        $(placeOrderButtonId).removeClass(phDisableButtonClass);
      } else if (!poMandatory && !termsCheckMandatory && (deliveryoptionShowstatus === 'false' && deliveryStatusContainer === 0)) {
        $(placeOrderButtonId).removeClass(phDisableButtonClass);
      } else if (!poMandatory && !termsCheckMandatory && (deliveryoptionShowstatus === 'true' &&
deliveryStatusContainer > 0 && $('input[name="modeCode"]').is(':checked'))) {
        $(placeOrderButtonId).removeClass(phDisableButtonClass);
      } else if (!poMandatory && !termsCheckMandatory && (deliveryoptionShowstatus === 'true' && deliveryStatusContainer === 0)) {
        $(placeOrderButtonId).removeClass(phDisableButtonClass);
      } else {
        $(placeOrderButtonId).addClass(phDisableButtonClass);
      }
    } else {
      $(placeOrderButtonId).addClass(phDisableButtonClass);
    }
  }
  /* eslint-enable complexity*/

  function formatShippingAddress() {
    var $formattedShippingAddress = $('#ph-formattedShippingAddress'),
        brTag = '<br>',
        company = $('#ph-companyValueEl').val(),
        addressArray = $('#ph-addressValueEl').val().split(','),
        countryName = addressArray[addressArray.length - 1],
        addressLength = addressArray.length,
        shippingAddress = '',
        streetName = '',
        clearCompanyName = '',
        formatterShippingAddress = '';

    addressArray.pop();
    $.each(addressArray, function(index, value) {
      if (index > addressLength - 5) {
        shippingAddress = shippingAddress + (value + ', ');
      } else {
        streetName = streetName + (value + ', ');
      }
    });

    if (typeof shippingAddress !== 'undefined' && typeof streetName !== 'undefined' && typeof clearCompanyName !== 'undefined') {
      shippingAddress = shippingAddress.trim().replace(/.$/, '');
      streetName = streetName.trim().replace(/.$/, '');
      clearCompanyName = company.replace(/[()]/g, '');
    }

    formatterShippingAddress = formatterShippingAddress + ($('#ph-customerIdValueEl').val() + ' - ' + clearCompanyName + brTag +
          streetName + brTag +
          shippingAddress + brTag +
          countryName);
    $formattedShippingAddress.append(formatterShippingAddress);
  }

  enableOrderButton();

  $('#termsCheck').click(function() {
    enableButtonOnTermsCheck();
  });

  $('#purchaseOrderNumber').blur(function() {
    activateButtonOnPoNumber();
  });


  function updateDeliveryMode(deliveryCode) {
    $('#termsCheck').prop('disabled', true);
    $.ajax({
      url: ACC.config.encodedContextPath + '/checkout/single/summary/setDeliveryMode.json',
      type: 'POST',
      datatype: 'json',
      data: {
        modeCode: deliveryCode
      },
      success: function(data) {
        $('#termsCheck').prop('disabled', false);

        if (data) {
          $('.ph-deliverymodeError').addClass('hidden');
          ACC.common.updateCartDetails(data);

          if (data.deliveryCost.formattedValue) {
            $('.ph-deliveryPrice_' + deliveryCode).html(data.deliveryCost.formattedValue);
          }

          $(placeOrderButtonId).removeClass(phDisableButtonClass);
          $(interstitialLoader).addClass('hidden');
          enableButtonOnTermsCheck();
          activateButtonOnPoNumber();
        } else {
          $('.ph-deliverymodeError').removeClass('hidden');
          $(interstitialLoader).addClass('hidden');
          $(placeOrderButtonId).addClass(phDisableButtonClass);
        }
      }
    });
  }

  if ($('.ph-wholeDeliveryOptions').length > 0) {
    if (defaultCode !== '' && defaultCode !== null) {
      $('input[name="modeCode"][value="' + defaultCode + '"]').each(function() {
        $(this).prop('checked', true);
      });
    }

    deliverymodeVal = $('input[name=\'modeCode\']:checked').val();

    /* eslint-disable no-undefined */
    if ($('input[name=\'modeCode\']:checked').val() !== undefined) {
    /* eslint-enable no-undefined */
      $(placeOrderButtonId).addClass(phDisableButtonClass);
      $(interstitialLoader).removeClass('hidden');
      updateDeliveryMode(deliverymodeVal);
    }
  }

  $(document).on('change', 'input[name="modeCode"]', function() {
    deliverymodeVal = $(this).val();

    $(placeOrderButtonId).addClass(phDisableButtonClass);
    $(interstitialLoader).removeClass('hidden');
    updateDeliveryMode(deliverymodeVal);
  });

  if ($('#ph-formattedShippingAddress').length > 0) {
    formatShippingAddress();
  }
});

/* eslint-enable vars-on-top */
/* eslint-enable require-jsdoc */
/* eslint-enable max-statements*/
/* eslint-enable max-len */
/* eslint-enable max-lines*/
/* eslint-enable xss/no-mixed-html*/
